import { ProductionFulfillmentApi, useAPIQuery } from "melco-shared-logic";

export const useDesignMapping = (designMappingId: string) => {
  return useAPIQuery(
    ProductionFulfillmentApi,
    ["designMapping", designMappingId],
    async (api) => {
      return api.productionFulfillmentMappingsGetMappings({
        id: designMappingId,
      });
    }
  );
};
